import React, { useEffect, useState } from "react";
import {ReactTyped} from 'react-typed';
import BetaBanner from "./BetaBanner";
import { dispatchCustomEvent } from "@/helpers/triggerAnalyticsEvent";
import cleanInput from "@/helpers/encodeValue";
 
function  setURLParams(input: string) {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.delete("q");
  history.pushState(
    null,
    "",
    `${window.location.pathname}?q=${encodeURIComponent(input)}`
  );
}

function getQueryParam(name: string, url?: string) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let recognition: any;

if ("SpeechRecognition" in window || "webkitSpeechRecognition" in window) {
  const SpeechRecognition =
    window.SpeechRecognition || window.webkitSpeechRecognition;

  recognition = new SpeechRecognition();
} else {
  // this will never be hit in prod, only for testing
  recognition = {
    start: () => {
      /* do nothing */
    },
  };
}

const Searchbar = ({
  showBeta = false,
  showSamples = false,
  onSearchSubmit = () => {},
  handlePrompt = () => {},
} : {
    showBeta?: boolean;
    showSamples ?: boolean;
    onSearchSubmit?: (query: boolean) => void;
    handlePrompt?: (query: string) => void;
}) => {
  const [value, setValue] = useState("");
  const [inputActive, setInputActive] = useState(false);
  const query = getQueryParam("q");

  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  const handleSubmit = () => {
    if (value.trim().length > 0) {
      const queryVal = value;
      
      setURLParams(queryVal);
      onSearchSubmit(true);
      handlePrompt(queryVal);
      dispatchCustomEvent({
        dataObject: "body-searchBar",
        dataType: "button",
        dataReason: "Search_Button_Click",
      });
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && value.length > 0) {
      handleSubmit();
    }
  };

  const handleInputMouseOver = () => {
    setTimeout(() => {
      setInputActive(true);
    }, 600);
  };

  const handleInputClick = () => {
    setInputActive(true);
  };

  const handleSpeechToText = () => {
    recognition.start();

    dispatchCustomEvent({
      dataObject: "body-searchBar",
      dataType: "button",
      dataReason: "voice_search_button",
    });
  };

  if ("SpeechRecognition" in window || "webkitSpeechRecognition" in window) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    recognition.onresult = (event: any) => {
      const { transcript } = event.results[0][0];

      if (transcript.length) {
        setValue(transcript);
        recognition.stop();

        dispatchCustomEvent({
          dataObject: "body-searchBar",
          dataType: "button",
          dataReason: `Internal Search Box Search Term-${String(
            transcript
          ).slice(0, 150)}`,
        });
        setURLParams(cleanInput(transcript));
        onSearchSubmit(true);
        handlePrompt(cleanInput(transcript));
      }
    };
  }

  useEffect(() => {
    if (query) {
      setValue(String(query[0].toUpperCase() + query.substring(1)));
    }
  }, [query]);

  return (
  <div className="flex flex-col gap-1 xs:h-[75px] md:min-w-[665px] lg:min-w-[872px]">
      <div className="peer flex items-center flex-col xs:flex-row sm:max-w-[877px] py-2 bg-white text-steel-gray rounded-[8px] shadow-[0px_4px_24px_0px_rgba(0,0,0,0.08)] align-top">
        <div className="flex w-[80%] mb-1 xs:mb-0 mx-24 xs:w-full border-b border-charcoal items-center justify-center mt-3 xs:ml-9 sm:ml-[67px] xs:mr-3 sm:mt-0 flex-shrink">
          <img
              src="data:image/svg+xml,%3csvg%20width='29'%20height='31'%20viewBox='0%200%2029%2031'%20fill='none'%20className='fill-inherit'%20xmlns='http://www.w3.org/2000/svg'%20aria-hidden='true'%3e%3cg%20id='Layer_1'%20clip-path='url(%23clip0_598_7461)'%3e%3cpath%20id='Vector'%20d='M28.3759%2027.8293L22.5593%2021.8271C24.1941%2019.6186%2025.089%2016.9114%2025.089%2014.0616C25.089%2012.5299%2024.8309%2011.0516%2024.3318%209.6624C23.0583%2010.1255%2022.043%2011.1051%2021.4923%2012.3696C21.5956%2012.9218%2021.6472%2013.4917%2021.6472%2014.0616C21.6472%2016.5551%2020.7007%2018.8883%2018.997%2020.6516C15.4864%2024.285%209.77295%2024.285%206.2623%2020.6516C4.5586%2018.8883%203.62931%2016.5551%203.62931%2014.0616C3.62931%2011.5681%204.5586%209.23495%206.2623%207.47169C7.67344%206.01121%209.44597%205.13849%2011.2873%204.85352C12.7157%204.23014%2014.5743%202.85872%2015.5036%201.52292C11.4422%200.525519%207.00229%201.6654%203.83582%204.94257C1.47818%207.38264%200.1875%2010.6242%200.1875%2014.0616C0.1875%2017.4991%201.47818%2020.7407%203.83582%2023.1629C6.2623%2025.6742%209.44597%2026.9388%2012.6296%2026.9388C15.2798%2026.9388%2017.93%2026.0661%2020.1328%2024.3384L25.9323%2030.3406C26.2764%2030.6968%2026.7067%2030.8749%2027.1541%2030.8749C27.6015%2030.8749%2028.0318%2030.6968%2028.3759%2030.3406C29.0471%2029.646%2029.0471%2028.5239%2028.3759%2027.8293Z'%20fill='currentColor'/%3e%3cpath%20id='Vector_2'%20d='M18.9626%200.347413L19.8575%203.99861C20.0468%204.76447%2020.6319%205.37003%2021.3719%205.56595L24.8997%206.4921C25.2611%206.58116%2025.2611%207.11548%2024.8997%207.22234L21.3719%208.1485C20.6319%208.34441%2020.0468%208.94998%2019.8575%209.71584L18.9626%2013.367C18.8765%2013.7411%2018.3603%2013.7411%2018.257%2013.367L17.3621%209.71584C17.1728%208.94998%2016.5877%208.34441%2015.8477%208.1485L12.3199%207.22234C11.9585%207.13329%2011.9585%206.59897%2012.3199%206.4921L15.8477%205.56595C16.5877%205.37003%2017.1728%204.76447%2017.3621%203.99861L18.257%200.347413C18.3431%20-0.0266116%2018.8593%20-0.0266116%2018.9626%200.347413Z'%20fill='currentColor'/%3e%3cpath%20id='Vector_3'%20d='M10.8743%209.16378L11.3562%2011.1051C11.4594%2011.5148%2011.7692%2011.8354%2012.165%2011.9423L14.0408%2012.441C14.2301%2012.4944%2014.2301%2012.7794%2014.0408%2012.8328L12.165%2013.3315C11.7692%2013.4384%2011.4594%2013.7589%2011.3562%2014.1686L10.8743%2016.11C10.8227%2016.3059%2010.5474%2016.3059%2010.4957%2016.11L10.0139%2014.1686C9.91062%2013.7589%209.60086%2013.4384%209.20505%2013.3315L7.32926%2012.8328C7.13996%2012.7794%207.13996%2012.4944%207.32926%2012.441L9.20505%2011.9423C9.60086%2011.8354%209.91062%2011.5148%2010.0139%2011.1051L10.4957%209.16378C10.5474%208.96787%2010.8227%208.96787%2010.8743%209.16378Z'%20fill='currentColor'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_598_7461'%3e%3crect%20width='28.6875'%20height='30.8125'%20fill='white'%20transform='translate(0.1875%200.0625)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e"
            alt=""
            className="ml-[-24px] xs:ml-[-18px] w-[16px] h-[18px] sm:w-[28px] sm:h-[30px] mb-[2px] mr-[10px] sm:mb-[4px] sm:mr-[7px] sm:ml-[-43px]"
          />
          <div
            className="w-full  sm:ml-[8px] mb-2 sm:pb-0 sm:mb-0 sm:mt-0 mr-[22px] flex group min-h-[34px]"
            onMouseOver={handleInputMouseOver}
            onFocus={handleInputMouseOver}
          >
            <input
              autoFocus={inputActive}
              type="text"
              id="mobile-search-bar"
              name="mobile-input"
              value={value}
              placeholder="ex: Furnishings inspired by a Movie"
              onChange={handleValueChange}
              onKeyDown={handleKeyDown}
              className="block sm:hidden h-[32px] mt-1 sm:mt-0 leading-[24px] text-[16px] sm:text-[20px] text-charcoal placeholder:text-[#3B3C39] tracking-[0.4px] outline-none mr-[12px] first-letter:uppercase w-full sm:w-[98%] line-clamp-1"
            />
            {inputActive || !showSamples || value ? (
              <input
                autoFocus={inputActive}
                type="text"
                id="search-bar"
                aria-describedby="search-description"
                aria-label="Type a sentence describing your shopping inspiration."
                name="large-input"
                value={value}
                placeholder="ex: Furnishings inspired by a Movie"
                onChange={handleValueChange}
                onKeyDown={handleKeyDown}
                className="hidden sm:block h-[32px] mt-1 sm:mt-0 leading-[24px] text-[16px] sm:text-[20px] text-charcoal placeholder:text-[#3B3C39] tracking-[0.4px] outline-none mr-[12px] first-letter:uppercase w-full sm:w-[98%] line-clamp-1"
              />
            ) : (
              <div
                className="hidden sm:inline sm:not-sr-only h-[12px] overflow-clip "
                onClick={handleInputClick}
                onFocus={handleInputClick}
                tabIndex={0}
                id="type-animation"
              >
                <ReactTyped 
                strings={["Find Home Furnishings inspired by Your Favorite Movie","Find Patio Furniture with a Mediterranean feel", "Make my basement Super Comfy"]}
                typeSpeed={40}
                backSpeed={50}
                loop
                className="text-[20px] text-charcoal tracking-[0.4px] mr-[12px] w-[98%] line-clamp-1"
                />
              </div>
            )}
          </div>

          <button
            onClick={handleSpeechToText}
            className="flex items-center justify-center xs:mr-3 sm:mt-0 flex-shrink"
          >
            <img
            src={searchPromptDetails?.voiceCmdImage}
              alt="speech to text"
              className="syfclickevent max-w-none"
              data-test="type-animation-div"
              data-object="body-searchBar"
              data-type="button"
              data-reason="voice_search_buttom"
            />
          </button>
        </div>
        <button
          onClick={handleSubmit}
          className="syfclickevent pt-[4px] mx-[16px] xs:mb-0 xs:ml-0 h-[48px] w-[90%] xs:w-[135px] rounded-[8px] text-charcoal uppercase font-bold tracking-[0.5px] leading-[24px] search-button mt-[6px] sm:mt-0"
          id="search-button"
          data-object="body-searchBar"
          data-type="button"
          data-reason="Search_Button_Click"
        >
          Search
        </button>
      </div>
      <BetaBanner showBeta={showBeta} />
    </div>
  );
};

export default Searchbar;
